require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-from-this-weekend-the-bend-is-playing-host-to-a-series.json") })
        }
      }, "path---news-from-this-weekend-the-bend-is-playing-host-to-a-series");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-from-this-weekend-the-bend-is-playing-host-to-a-series!./.cache/json/news-from-this-weekend-the-bend-is-playing-host-to-a-series.json
// module id = 814
// module chunks = 231608221292675